// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2bqj1","toggle":"styles_toggle__3yjFM","preview":"styles_preview__zVOiY"};